import Discount from "@/orm/models/Company/Discount";
import { computed } from '@vue/composition-api';

export default function useDiscount() {
  const discountInfo = computed(() => Discount.all());

  async function fetchDiscountInfo() {
    await Discount.api().fetchDiscountInfo()
  }

  return {
    fetchDiscountInfo,
    discountInfo
  };
}
